import React from "react";
import { useTranslation } from "react-i18next";

const EyeDonationHeader = ({ mediaUrls, isMobile, isAlternate }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        position: "relative",
        zIndex: 6,
        marginBottom: "60px",
        // backgroundImage: "url('assets/img/section-bg/polygon-pattern.png')",
      }}
    >
      {/* Floating Circle Icon */}
      <div
        style={{
          position: "absolute",
          top: isMobile ? -80 : 270, // Half floating out
          left: "50%",
          transform: "translateX(-50%)",
          width: 140,
          height: 140,
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
          backgroundColor: isAlternate ? "var(--color-fourth)" : "white",
          zIndex: 7,

          // border: "1px solid var(--color-fourth)",
        }}
      >
        <img
          src={mediaUrls?.eyeDonateIcon}
          alt="icon"
          style={{
            height: 100,
            filter: isAlternate
              ? "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)" // makes icon white
              : "invert(17%) sepia(32%) saturate(1150%) hue-rotate(180deg) brightness(94%) contrast(90%)",
            borderRadius: 6,
          }}
        />
      </div>

      {/* Title & Description */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 45,
            color: "black",
            // fontWeight: 700,
            // paddingTop: -26, // Push content below floating icon
            marginTop: "80px",
          }}
        >
          {t("home.eyeDonationTitle") || "Support Eye Donation"}
        </h2>
        <p
          style={{
            maxWidth: 1200,
            marginTop: 15,
            marginBottom: "30px",
            color: "var(--color-doctor)",
            fontSize: 32,
            // fontWeight: 700,
          }}
        >
          {t("home.eyeDonationDescription") ||
            "Small actions can restore someone's sight."}
        </p>
      </div>
    </div>
  );
};

export default EyeDonationHeader;
